import {
  AlertOctagon,
  AlertTriangle,
  CheckCircle2,
  Clock,
  Copy,
  Repeat,
  SearchCheck,
  XCircle,
} from "lucide-react";

export const STATUS = {
  til_betaling: { label: "Til betaling", icon: Clock, description: "Bekreftet og klar til betaling" },
  forfaller_snart: { label: "Forfaller snart", icon: AlertTriangle, description: "Forfaller innen påminnelsesperioden" },
  forfalt: { label: "Forfalt", icon: AlertOctagon, description: "Forfallsdato er passert" },
  ma_kontrolleres: { label: "Må kontrolleres", icon: SearchCheck, description: "Vi var usikre på noen felt" },
  mulig_duplikat: { label: "Mulig duplikat", icon: Copy, description: "Ligner på en regning du allerede har" },
  betalt: { label: "Betalt", icon: CheckCircle2, description: "Markert som betalt" },
  avtalegiro: { label: "AvtaleGiro", icon: Repeat, description: "Trekkes automatisk" },
  avvist: { label: "Avvist (duplikat)", icon: XCircle, description: "Slått sammen med en annen faktura" },
};

export const STATUS_TABS = [
  { value: "alle", label: "Alle" },
  { value: "til_betaling", label: "Til betaling" },
  { value: "forfaller_snart", label: "Forfaller snart" },
  { value: "forfalt", label: "Forfalt" },
  { value: "ma_kontrolleres", label: "Må kontrolleres" },
  { value: "mulig_duplikat", label: "Mulig duplikat" },
  { value: "avtalegiro", label: "AvtaleGiro" },
  { value: "betalt", label: "Betalt" },
];

export const SOURCES = {
  opplasting: "Opplasting",
  epost: "E-post",
  ehf: "EHF / Peppol",
  efaktura: "eFaktura",
  vipps: "Vipps",
  digipost: "Digipost",
  eboks: "e-Boks",
  papir: "Papir",
  avtalegiro: "AvtaleGiro",
  manuell: "Manuell",
};

export const PAYMENT_TYPES = {
  faktura: "Faktura",
  avtalegiro: "AvtaleGiro",
  kreditnota: "Kreditnota",
};

export const FIELD_LABELS = {
  issuer_name: "Leverandør",
  issuer_org_number: "Organisasjonsnummer",
  invoice_number: "Fakturanummer",
  amount: "Beløp",
  currency: "Valuta",
  invoice_date: "Fakturadato",
  due_date: "Forfallsdato",
  account_number: "Kontonummer",
  kid: "KID",
  description: "Beskrivelse",
  payment_type: "Betalingstype",
  source: "Kilde",
  category_id: "Kategori",
  notes: "Notater",
};

export const AUDIT_ACTIONS = {
  register: "Konto opprettet",
  delegation_linked: "Invitasjon til fullmakt koblet til konto",
  delegation_claimed: "Invitasjon koblet via lenke",
  email_verified: "E-postadresse bekreftet",
  email_verification_resent: "Bekreftelses-e-post sendt på nytt",
  bankid_linked: "BankID koblet til kontoen",
  bankid_unlinked: "BankID koblet fra",
  delegation_invite_resend: "Invitasjon sendt på nytt",
  login: "Innlogging",
  login_failed: "Mislykket innlogging",
  logout: "Utlogging",
  password_changed: "Passord endret",
  invoice_create: "Faktura opprettet",
  invoice_view: "Faktura åpnet",
  document_view: "Dokument vist",
  invoice_update: "Faktura endret",
  invoice_confirm: "Faktura bekreftet",
  invoice_paid: "Markert som betalt",
  invoice_unpaid: "Betaling angret",
  invoice_delete: "Faktura slettet",
  invoice_merge_duplicate: "Duplikater slått sammen",
  invoice_dismiss_duplicate: "Duplikat avvist",
  invoice_flag_dismissed: "Advarsel avvist",
  invoice_bulk_category: "Massekategorisering",
  export_csv: "CSV-eksport",
  export_all: "Dataeksport",
  settings_update: "Innstillinger endret",
  forwarding_rotated: "Videresendingsadresse fornyet",
  category_create: "Kategori opprettet",
  category_update: "Kategori endret",
  category_delete: "Kategori slettet",
  supplier_update: "Leverandør endret",
  supplier_apply_category: "Kategori brukt på leverandør",
  supplier_delete: "Leverandør slettet",
  account_deleted: "Konto slettet",
  admin_user_activate: "Admin: bruker aktivert",
  admin_user_deactivate: "Admin: bruker deaktivert",
  admin_user_update: "Admin: bruker endret",
  admin_settings_update: "Admin: innstillinger endret",
  admin_audit_export: "Admin: revisjonslogg eksportert",
};

export const CATEGORY_COLORS = ["#0E7490", "#1E7A3A", "#3730A3", "#6D28D9", "#8A5A00", "#B42318", "#1D4ED8", "#0F766E", "#9F1239", "#5B6776"];
